import React from 'react';
import Login from './Login';
import { useAuth } from '../hooks/useAuth';

/** Shared SMS verification entry point for account and legacy app URLs. */
const AuthEntry: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-aspen-warm-ivory dark:bg-aspen-night-sage" aria-label="Loading account"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-aspen-sage-teal" /></div>;
  }
  return isAuthenticated ? <>{children}</> : <Login onLoginSuccess={login} />;
};

export default AuthEntry;
